import { IPageName } from '../../common/types/apiSchema';
import { BePaths } from './BePaths';
import { CsPaths } from './CsPaths';
import { DaPaths } from './DaPaths';
import { DePaths } from './DePaths';
import { EsPaths } from './EsPaths';
import { FrPaths } from './FrPaths';
import { HuPaths } from './HuPaths';
import { ItPaths } from './ItPaths';
import { NlPaths } from './NlPaths';
import { NoPaths } from './NoPaths';
import { SkPaths } from './SkPaths';
import { SvPaths } from './SvPaths';

export type PathMap = {
  [k in IPageName]?: string[];
};

const DefaultPaths: PathMap = {
  [IPageName.searchResults]: ['/search/search'],
  [IPageName.salePage]: ['(/+):saleId/(sale|sale-hotel)'],
  [IPageName.travelBirdSalePage]: ['/:saleslug/sale-goose'], // has to match eg:'/harry-potter-london-uk/sale-goose'
  [IPageName.currentSales]: ['/current-sales'],
  [IPageName.collections]: ['/:filterslug/filter'],
  [IPageName.bookingsPage]: ['/bookings'],
  [IPageName.bookingDetailsPage]: ['/bookings/:bookingId/details'],
  [IPageName.cancellationPage]: ['/bookings/:bookingId/cancellation'],
  [IPageName.bookingAmendmentsPage]: ['/bookings/:bookingId/bookingAmendment'],
  [IPageName.instantAccess]: [
    '/',
    '/auth/login',
    '/instantAccess/index',
    '/instant-access/:affiliate',
  ],
};

const pathMaps: PathMap[] = [
  DefaultPaths,
  BePaths,
  CsPaths,
  DaPaths,
  DePaths,
  EsPaths,
  FrPaths,
  HuPaths,
  ItPaths,
  NlPaths,
  NoPaths,
  SkPaths,
  SvPaths,
];

export const getPaths: (page: IPageName) => string[] = page => {
  const paths: Set<string> = new Set<string>();
  pathMaps.forEach(territory => {
    const territoryPaths: string[] = territory[page];
    if (territoryPaths) {
      territoryPaths.forEach(path => {
        paths.add(path);
        paths.add(`/flashsales${path}`);
      });
    }
  });

  return [...paths];
};
